module.exports = __webpack_public_path__ + "img/deliveryInventory.b5b7d18b.png";